import React from 'react'
import borderbox1 from "../../assets/images/bordercard2.png"
import Typhone from "../../assets/images/Typhone-offshore.png"



const CustomersFeddback = () => {
    return (
        <>
            <section id='customerfeedback' className='mt-[-12px] xl:mt-[-90px]'>
                <div className='container' >
                    <h2 style={{ textShadow: "0px 0px 20px #2972D7" }} className=' text-[28px] md:text-[32px] lg:text-[40px] xl:text-[50px] text-white text-center font-gothicproMedium leading-[100%]  drop-shadow-custom relative z-20 lg:mt-[0px] md:mt-[-35px] mt-[20px]'>// CUSTOMER FEEDBACK</h2>
                    
                    <div className='relative lg:hidden my-8 md:px-[90px] px-[20px]'>
                            <div className="relative text-[#C9C9C9] text-[16px] leading-[140%] font-inter text-center
                                after:content-['“']
                                 after:custom-glow
                                after:text-[50px] 
                                after:leading-[52.34px]
                                after:text-white
                                after:font-gothicproMedium
                                after:absolute 
                                after:top-[-10px]
                                after:left-[-48px]
                                after:w-[47px]
                                after:h-[87px]
                                before:content-['”']
                                before:absolute 
                                before:right-[-35px]
                                before:bottom-[-62px]
                                before:text-[50px] 
                                before:leading-[52.34px]
                                before:font-gothicproMedium
                                before:w-[47px]
                                before:h-[87px]
                                before:text-white
                                before:custom-glow
                                pl-8 pr-8">
                                Having a tool that <span className='font-bold text-white'>continuously monitors</span> the risk of internet-exposed assets has been essential to our company. The <span className='font-bold text-white'>Armory</span> team <span className='font-bold text-white'>consistently supports us</span> with their expertise, proactive attitude and initiatives.
                            </div>
                        </div>
                    <div className='flex flex-col lg:flex-row items-center justify-between gap-5 lg:gap-16 md:gap-6 w-full mx-auto lg:pt-[60px] md:pt-[28px] pt-[18px]'>
                        {/* Left Column - Customer Details (Slightly Wider on Desktop) */}
                        <div className='flex flex-col items-center md:items-center lg:items-start lg:flex-[0.5] lg:pl-[130px]'>
                            <img className='max-w-[254px] h-[73px] mb-6' src={Typhone} alt="Typhone" />
                            <div className='text-center lg:text-left'>
                                <h3 className='lg:text-[24px] md:text-[20px] text-[20px] font-gothicproMedium leading-[100%] lg:leading-[110%] text-white mb-2'>
                                    Ricardo Carapia
                                </h3>
                                <h4 className='lg:text-[18px] md:text-[16px] text-[16px] font-gothicproMedium leading-[100%] text-[#2972D7] lg:pr-[53px]'>
                                    CHIEF INFORMATION SECURITY OFFICER
                                </h4>
                            </div>
                        </div>

                        {/* Right Column - Testimonial (Slightly Narrower on Desktop) */}
                        <div className='relative hidden md:hidden lg:block lg:flex-[1] lg:right-[152px]'>
                            <div className="relative text-[#C9C9C9] text-[16px] leading-[140%] font-inter
                                after:content-['“']
                                 after:custom-glow
                                after:text-[50px] 
                                after:leading-[52.34px]
                                after:text-white
                                after:font-gothicproMedium
                                after:absolute 
                                after:top-[-10px]
                                after:left-[-48px]
                                lg:after:left-[56px]
                                lg:before:right-[80px]
                                after:w-[47px]
                                after:h-[87px]
                                before:content-['”']
                                before:absolute 
                                before:right-[-35px]
                                before:bottom-[-62px]
                                before:text-[50px] 
                                before:leading-[52.34px]
                                before:font-gothicproMedium
                                before:w-[47px]
                                before:h-[87px]
                                before:text-white
                                before:custom-glow
                                pl-8 pr-8

                                lg:pl-[120px]
                                lg:pr-[120px]
                                lg:text-center
                                ">
                                Having a tool that <span className='font-bold text-white'>continuously monitors</span> the risk of internet-exposed assets has been essential to our company. The <span className='font-bold text-white'>Armory</span> team <span className='font-bold text-white'>consistently supports us</span> with their expertise, proactive attitude and initiatives.
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default CustomersFeddback
